import { createFileRoute } from "@tanstack/react-router";
import { InsightsPage } from "@/app/connect/pages/insights";

type InsightsSearchParams = {
	provider_id?: string;
};

/**
 * Strip surrounding quotes from a value (handles URLs like ?provider_id="382")
 */
function cleanId(value: unknown): string | undefined {
	if (typeof value === "number") return String(value);
	if (typeof value === "string") {
		const cleaned = value.replace(/^["']|["']$/g, "");
		return cleaned || undefined;
	}
	return undefined;
}

export const Route = createFileRoute("/connect/")({
	validateSearch: (search: Record<string, unknown>): InsightsSearchParams => ({
		provider_id: cleanId(search.provider_id),
	}),
	component: InsightsPage,
});
